import { Col, Form } from "react-bootstrap";
import Insurance from "../../../modules/components/shipmentDeceleration/Insurance";
import { useEffect, useState } from "react";
import { getRequestByAuth } from "../../../function/helper";
import DekapostInsurance from "../../../modules/pages/newLetter/components/order/DekapostInsurance";

function CompanySection({ state: { company, setCompany }, type = 1 }) {
  const [serviceOption, setServiceOption] = useState([]);

  const getData = async () => {
    const url =
      "/componyservices/v1/allBulk?type=" + (type === 2 ? "avaBox" : "avaShop");
    const response = await getRequestByAuth(url);

    if (response && response.status === 200) {
      setServiceOption(response.result);
    }
  };

  useEffect(() => {
    getData();
  }, []);

  const shopWeight = (
    <ul className="mb-0">
      <li>پست پیشتاز و پست خارجی 30 کیلوگرم</li>
      <li>بسته پستی در شرکت های خصوصی 100 کیلوگرم</li>
      <li>عدم ارسال بار بیشتر از 100 سانتی متر در یکی از ابعاد در سرویس پست</li>
      <li>
        عدم ارسال بار بیشتر از 250 سانتی متر در یکی از ابعاد در سرویس خصوصی
      </li>
    </ul>
  );

  const avaBoxWeight = (
    <ul>
      <li>بسته پستی برای پیک درون شهری موتوری 20 کیلو گرم</li>
      <li>بسته پستی برای پیک درون شهری خودرویی 500 کیلو گرم</li>
    </ul>
  );

  return (
    <section className="pt-3">
      <hr />

      <Col xs={12} md={6} lg={4} className="py-3">
        <Form.Label>انتخاب نوع سرویس</Form.Label>
        <Form.Select
          as="select"
          value={company.value}
          onChange={e => {
            const index = parseInt(e.target.value);

            setCompany({
              selected: index > -1 ? serviceOption[index] : {},
              value: parseInt(e.target.value),
            });
          }}
        >
          <option value={-1}>...</option>
          {serviceOption.map((data, index) => {
            return (
              <option className="fw-bold" value={index} key={index}>
                {data.title}
              </option>
            );
          })}
        </Form.Select>
      </Col>

      <hr />

      <div className="d-flex flex-wrap justify-content-around row-gap-2">
        <Col xs={12} lg={6} xxl={5}>
          <p className="h6 fw-bold text-end">
            محدودیت های حداکثر وزنی مرسولات پستی بشرح زیر می باشد:
          </p>
          {type === 2 ? avaBoxWeight : shopWeight}
        </Col>

        {type !== 2 && (
          <Col xs={12} lg={6} xxl={5}>
            <p className="h6 fw-bold text-end">
              بیمه مرسولات شما توسط آواکس بصورت زیر میباشد:
            </p>
            <ul className="mb-0">
              <li>انتخاب بیمه الزامی است.</li>
              <li>حداقل ارزش کالا ده میلیون ريال در نظر گرفته می شود.</li>
              <li>
                <Insurance />
              </li>
              <DekapostInsurance />
            </ul>
          </Col>
        )}
      </div>
      <hr />
    </section>
  );
}

export default CompanySection;
